import React from 'react';

interface ITariffProps {
  tariffResults: any;
  productValue: number;
  materialPct?: number;
  dutyCost?: number;
  totalCost?: number;
  baseCost?: number;
  displayAdditionalRate?: string;
  tariffCandidates?: any[];
  enabledExclusions?: Record<string, boolean>;
  toggleExclusion?: (codeDigits: string, enabled: boolean) => void;
  ftaOptions?: FtaOption[];
  enabledFtas?: Record<string, boolean>;
  toggleFta?: (code: string, enabled: boolean) => void;
  explanationText: string;
  aiLoading: boolean;
}

type FtaOption = { code: string; name: string };

const ProductDescComp: React.FC<ITariffProps> = ({ tariffResults }) => {
  const safeTariffResults =
    tariffResults && typeof tariffResults === 'object' ? tariffResults : {};
  // --- Normalize "live" vs "snapshot" shapes --------------------------------
  const isSnapshot = Boolean(
    safeTariffResults.inputs &&
      safeTariffResults.base &&
      safeTariffResults.results,
  );

  const productDesc: string =
    (isSnapshot
      ? safeTariffResults.base?.productDesc
      : safeTariffResults.productDesc) ?? '';

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        {/* LEFT */}
        <div className='tariff-container-left'>
          <div>
            <div className='tariff-desc-text'>{productDesc}</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductDescComp;
